import React from 'react';
import { useTranslation } from 'react-i18next';

const PolicyClassification: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return(
    <div className={'policyAndClassificationContainer'}> 
      <div className='countryPolicy'>
        <div className="list-view-title-container">
          <p className="label-list-mode">{t('countryData:policy.geopolitics')}</p>
        </div>
        <ul style={{listStyleType: "none", lineHeight: '100%'}}>
          <li><span style={{backgroundColor:"#00a808", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>A</span>{t('countryData:policy.noRestriction')}</li>
          <li><span style={{backgroundColor:"#0e6fed", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>B</span>{t('countryData:policy.flexibleLandPolicy')}</li>
          <li><span style={{backgroundColor:"#ffd401", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>C</span>{t('countryData:policy.restrictiveLandPolicy')}</li>
          <li><span style={{backgroundColor:"#fb9100", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>D</span>{t('countryData:policy.specificRestrictions')}</li>
          <li><span style={{backgroundColor:"#e6193f", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>E</span>{t('countryData:policy.offCover')}</li>
        </ul>
      </div>
      <div className='countryClassification'>
        <div className="list-view-title-container">
          <p className="label-list-mode">{t('countryData:classification.landClasses')}</p>
        </div>
        <ul style={{listStyleType: "none", lineHeight: '100%'}}>
        <li><span style={{backgroundColor:"#383838", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>0</span>{t('countryData:classification.economy')}</li>
          <li><span style={{backgroundColor:"#383838", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>1</span>{t('countryData:classification.solvencyExcellent')}</li>
          <li><span style={{backgroundColor:"#383838", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>2</span>{t('countryData:classification.solvencyGood')}</li>
          <li><span style={{backgroundColor:"#383838", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>3</span>{t('countryData:classification.solvencySufficient')}</li>
          <li><span style={{backgroundColor:"#383838", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>4</span>{t('countryData:classification.solvencyModerate')}</li>
          <li><span style={{backgroundColor:"#383838", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>5</span>{t('countryData:classification.solvencyMediocre')}</li>
          <li><span style={{backgroundColor:"#383838", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>6</span>{t('countryData:classification.solvencyWeak')}</li>
          <li><span style={{backgroundColor:"#383838", padding:"0 0.5rem", color: "white", marginRight: "0.5rem"}}>7</span>{t('countryData:classification.solvencyPoor')}</li>
        </ul>
      </div>
    </div>
  )
}

export default PolicyClassification;
